import { render, staticRenderFns } from "./LogoFile.vue?vue&type=template&id=3fa731f2&"
import script from "./LogoFile.vue?vue&type=script&lang=js&"
export * from "./LogoFile.vue?vue&type=script&lang=js&"
import style0 from "./LogoFile.vue?vue&type=style&index=0&id=3fa731f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports